import { render, staticRenderFns } from "./AdminRejectionsReasons.vue?vue&type=template&id=19c87fd4&scoped=true&"
import script from "./AdminRejectionsReasons.vue?vue&type=script&lang=js&"
export * from "./AdminRejectionsReasons.vue?vue&type=script&lang=js&"
import style0 from "./AdminRejectionsReasons.vue?vue&type=style&index=0&id=19c87fd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c87fd4",
  null
  
)

export default component.exports